const ru = {
  howUseful: 'Насколько полезным вы нашли этот материал?',
  notUseful: 'Не полезно',
  veryUseful: 'Очень полезно',
  thanks: 'Спасибо за ваш вклад в развитие проекта!',
};

export default ru;
